import { MonitorCloud, LayoutGrid } from 'lucide-react';
import type { SideRailItem } from '@vizial-ui/components';

export interface NavItem extends SideRailItem {
  path?: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    key: 'all-modules',
    label: 'All Module',
    icon: LayoutGrid,
    section: 'ALL MODULES',
    path: '/',
  },
  // Todo: This to be removed in the next PR.
  //{
  //   key: 'connectivity',
  //   label: 'Connectivity',
  //   icon: ShieldCheck,
  //   section: 'SERVICE INSIGHTS',
  //   path: '/connectivity/dashboard',
  // },
  {
    key: 'monitoring',
    label: 'Monitoring',
    icon: MonitorCloud,
    section: 'CONNECTIVITY',
    path: '/monitoring',
  },
];
